import {
  createAsyncThunk,
  createSlice,
  Dispatch,
  PayloadAction,
} from '@reduxjs/toolkit';
import { Constants } from '../../../constants';
import { LuggageDataType } from '../../../types/common';

export interface InspactOrder {
  orderNumber: string;
  propertyLoanId: string;
  // departmentCode: string;
  // department: string;
  // workCode: string;
  // orderStatus: string;
  // orderDate: string;
  // dueDate: string;
  // billTo: string;
  // vendorCode: string;
  // invoiceNumber: string;
  // spiPropertyId: string;
  // clientCode: string;
  // workflowStateName: string;
  // workflowStateGroupName: string;
  // clientRequestDate: string;
  // clientUpload: string;
  // addressLine1: string;
  // addressLine2: string;
  // city: string;
  // zip: string;
  // orderDescription: string;
  // loanType: string;
  // fTVDate: string;
  // saleDate: string;
  // secureDate: string;
  // conveyDate: string;
}

interface OrderState {
  currentOrder: InspactOrder | null;
  recentOrders: InspactOrder[];
  luggage: LuggageDataType;
}

const initialState: OrderState = {
  currentOrder: null,
  recentOrders: [],
  luggage: {},
};

const inspectOrderSlice = createSlice({
  name: 'inspectOrder',
  initialState,
  reducers: {
    setOrder: (state, action: PayloadAction<InspactOrder>) => {
      state.currentOrder = action.payload;
    },
    resetOrder: () => initialState,
    setRecentOrders: (state, action: PayloadAction<InspactOrder[]>) => {
      state.recentOrders = action.payload;
    },
    setLuggageData: (state, action: PayloadAction<LuggageDataType>) => {
      state.luggage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadRecentOrders.fulfilled, (state, action) => {
      state.recentOrders = action.payload;
    });
  },
});

export const { setOrder, resetOrder, setRecentOrders, setLuggageData } =
  inspectOrderSlice.actions;
export default inspectOrderSlice.reducer;

export const updateRecentOrders = (dispatch: Dispatch, order: InspactOrder) => {
  let recentOrders: InspactOrder[] = JSON.parse(
    localStorage.getItem('recentOrders') || '[]'
  );
  recentOrders = recentOrders.filter(
    (o) => o.orderNumber !== order.orderNumber
  );

  recentOrders.unshift(order);

  // Ensure the array length does not exceed 20
  if (recentOrders.length > Constants.SEARCH_HISTORY_LIMIT) {
    recentOrders.pop(); // Remove the last element (oldest order)
  }

  localStorage.setItem('recentOrders', JSON.stringify(recentOrders));
  dispatch(setRecentOrders(recentOrders));
};

export const loadRecentOrders = createAsyncThunk(
  'orders/loadRecentOrders',
  async (_) => {
    const recentOrders: InspactOrder[] = JSON.parse(
      localStorage.getItem('recentOrders') || '[]'
    );
    return recentOrders;
  }
);
